import * as XLSX from 'xlsx';

const parseCsvLine = (line: string): string[] => {
  const cells: string[] = [];
  let current = '';
  let inQuotes = false;
  let i = 0;
  while (i < line.length) {
    const char = line[i] ?? '';
    if (inQuotes) {
      if (char === '"') {
        const next = line[i + 1];
        if (next === '"') {
          current += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i += 1;
        continue;
      }
      current += char;
      i += 1;
      continue;
    }
    if (char === '"') {
      inQuotes = true;
      i += 1;
      continue;
    }
    if (char === ',') {
      cells.push(current);
      current = '';
      i += 1;
      continue;
    }
    current += char;
    i += 1;
  }
  cells.push(current);
  return cells;
};

const isXlsxValidationFile = (file: File): boolean => {
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();
  return (
    fileName.endsWith('.xlsx') ||
    fileType.includes('spreadsheetml') ||
    fileType.includes('ms-excel')
  );
};

const normalizeCell = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (value instanceof Date) return value.toISOString();
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'bigint'
  ) {
    return String(value);
  }
  return '';
};

export const parseValidationRows = async (file: File): Promise<string[][]> => {
  if (isXlsxValidationFile(file)) {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, {
      type: 'array',
      cellDates: true,
      raw: true,
    });
    const firstSheetName = workbook.SheetNames[0];
    if (!firstSheetName) return [];
    const worksheet = workbook.Sheets[firstSheetName];
    const rows = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      raw: true,
      blankrows: false,
      defval: '',
    }) as unknown[];
    return rows.map((row) => (Array.isArray(row) ? row.map(normalizeCell) : []));
  }

  const text = await file.text();
  const normalized = text.replace(/^\uFEFF/, '');
  const lines = normalized.split(/\r?\n/).filter((line) => line.trim().length > 0);
  return lines.map((line) => parseCsvLine(line));
};
